import React from 'react';
import PropTypes from 'prop-types';
import { ArrowUp, ArrowDown, Star } from 'lucide-react';
import './styles/priority-badge.css';

/**
 * A badge component that visually represents priority levels with colors and icons
 * @param {string} level - The priority level (HIGH, MEDIUM, LOW)
 */
export default function PriorityBadge({ level }) {
  if (!level) return null;
  
  const className = `priority-badge priority-${level.toLowerCase()}`;
  
  const getIcon = () => {
    switch (level) {
      case 'HIGH': return <ArrowUp className="badge-icon" />;
      case 'MEDIUM': return <Star className="badge-icon" />;
      case 'LOW': return <ArrowDown className="badge-icon" />;
      default: return <Star className="badge-icon" />;
    }
  };

  return (
    <span className={className}>
      {getIcon()} {level}
    </span>
  );
}

PriorityBadge.propTypes = {
  level: PropTypes.string
};